<template>
  <v-card flat>
    <v-card-title primary-title>
      <v-icon left color="grey">mdi-access-point</v-icon>
      {{ $t("Sensors") }}
    </v-card-title>

    <v-card-text>
      <v-data-table
        v-model="selectedItems"
        :headers="customHeaders || headers"
        :items="points"
        item-key="label"
        show-select
        :loading="loading"
        loading-text="Loading... Please wait"
        :items-per-page="itemsPerPage || 10"
      >

      <!-- Cuastom slot to manage points selection -->
      <template v-slot:[`header.data-table-select`]="{ on }">
        <v-simple-checkbox
          :value="isAllSelected"
          :indeterminate="isSomeSelected"
          v-on="on"
          @click="toggleSelectAll"
        ></v-simple-checkbox>
      </template>


        <template slot="header.label" slot-scope="data">
          <span v-if="!selectedItems.length">{{ data.header.text }}</span>
          <span v-else>{{ data.header.text }} ({{ selectedItems.length }})</span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: [
    "itemsPerPage",
    "customHeaders",
    "selected",
    "updateSelected",
    "pointsType",
  ],
  data() {
    return {
      selectedItems: this.$props.selected || [],
      headers: [
        { text: "Sensor", align: "start", sortable: true, value: "label" },
        { text: "Type", align: "start", sortable: true, value: "sensorModel" },
      ],
      points: [],
      loading: false,
    };
  },
  watch:{
    selectedItems(){
      this.$emit('update-point-father', this.selectedItems);
    }
  },
  computed: {
    // Check if all elements are selected
    isAllSelected() {
      return this.points.length > 0 && this.selectedItems.length === this.points.length;
    },
    
    // Check if some points are selected for indeterminate state
    isSomeSelected() {
      return this.selectedItems.length > 0 && this.selectedItems.length < this.points.length;
    }
  },
  methods: {
    async loadData({ area, element, structure, sensor, type }) {
      this.loading = true;

      if (this.pointsType && this.pointsType === "all") {
        this.points = await this.$store.dispatch("_getPoints");
      } else {
        const data = {
          areaId: area ? area.areaId : undefined,
          elementId: element ? element.elementId : undefined,
          structureId: structure ? structure.structureId : undefined,
          sensorModel: type || undefined,
          label: sensor || undefined,
        };
        this.points = await this.$store.dispatch("_getPlantPoints", data);
      }

      if (this.selected) {
        this.points = [...this.selected, ...this.points];
      } else {
        this.selectedItems = [];
      }

      this.loading = false;
    },
    async onFilter({ area, element, structure, sensor, type }) {
      await this.loadData({
        area,
        element,
        structure,
        sensor,
        type,
      });
    },

     // Manage select all checkbox
    toggleSelectAll() {
      // This ia a Vuetify method that toggles the select all checkbox
      // We overwrite it for custom behaviour

      if (this.isAllSelected) {
        this.deselectAllItems();
      } else {
        this.selectAllItems();
      }
    },
    
    // Seleziona tutti gli elementi (in tutte le pagine)
    selectAllItems() {
      this.selectedItems = [...this.points];
    },
    
    // Deseleziona tutti gli elementi
    deselectAllItems() {
      this.selectedItems = [];
    },
  },
  created: function () {},
};
</script>
